import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Calendar from './components/Calendar/Calendar';
import BudgetDashboard from './components/Budget/BudgetDashboard';
import ExpensesList from './components/Expenses/ExpensesList';
import Settings from './components/Settings/Settings';
import LoadingSpinner from './components/UI/LoadingSpinner';
import { PageErrorBoundary, SectionErrorBoundary } from './components/UI/ErrorBoundary';
import { ToastContainer } from './components/UI/Toast';

function App() {
  const { user, loading, error } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-slate-600">Loading your itinerary...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-slate-900 mb-2">Authentication Required</h1>
          <p className="text-slate-600 mb-6">{error}</p>
          <p className="text-sm text-slate-500">
            This app is protected by Cloudflare Access. Please ensure you're signed in with an authorized account.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageErrorBoundary>
        <Layout>
          <Routes>
            <Route path="/" element={
              <SectionErrorBoundary title="Calendar failed to load">
                <Calendar />
              </SectionErrorBoundary>
            } />
            <Route path="/budget" element={
              <SectionErrorBoundary title="Budget dashboard failed to load">
                <BudgetDashboard />
              </SectionErrorBoundary>
            } />
            <Route path="/expenses" element={
              <SectionErrorBoundary title="Expenses list failed to load">
                <ExpensesList />
              </SectionErrorBoundary>
            } />
            <Route path="/settings" element={
              <SectionErrorBoundary title="Settings failed to load">
                <Settings />
              </SectionErrorBoundary>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </PageErrorBoundary>
      <ToastContainer />
    </>
  );
}

export default App;
